module.exports = __webpack_public_path__ + "assets/img/navTopBg.2130e1e3.png";